import React, { createContext, useState } from "react";

export const ChatContext = createContext(null)

export default function ChatContextProvider(props) {
    const [employee, setEmployee] = useState([])

    const [visisibiltyContact, setVisisibiltyContact]                           = useState("d-none")
    const [visisibiltyRoom, setVisisibiltyRoom]                                 = useState("d-block")
    const [visibilityGroupInformation, setVisibilityGroupInformation]           = useState("d-none")
    const [visibilityModalContact, setVisibilityModalContact]                   = useState(false)
    const [visibilityModalCreateGroup, setVisibilityModalCreateGroup]           = useState(false)
    const [visibilityModalAddMemberGroup, setVisibilityModalAddMemberGroup]     = useState(false)
    const [visibilityModalForwardMessage, setVisibilityModalForwardMessage]     = useState(false)

    const changeVisibilityContact = (visible) => {
        setVisisibiltyContact("d-block col-12")
        setVisisibiltyRoom("d-block")
        setVisibilityGroupInformation("d-none")
    }

    const changeVisibilityRoom = (visible) => {
        setVisisibiltyContact("d-none")
        setVisisibiltyRoom("d-block")
        setVisibilityGroupInformation("d-none")
    }

    const changeVisibilityGroupInformation = (visible) => {
        let classNameGroupInformation = visible === true ? "d-block col-lg-auto col-12 ml-0" : "d-none"
        let classNameRoom = visible === true ? "d-none" : "d-block"
        let classNameContact = visible === true ? "d-none" : "d-none"
        setVisibilityGroupInformation(classNameGroupInformation)
        setVisisibiltyRoom(classNameRoom)
        setVisisibiltyContact(classNameContact)
    }

    return (
        <>
            <ChatContext.Provider value={
                {
                    employee, setEmployee,
                    visisibiltyContact, changeVisibilityContact,
                    visisibiltyRoom, changeVisibilityRoom,
                    visibilityModalContact, setVisibilityModalContact,
                    visibilityModalCreateGroup, setVisibilityModalCreateGroup,
                    visibilityModalAddMemberGroup, setVisibilityModalAddMemberGroup,
                    visibilityGroupInformation, changeVisibilityGroupInformation,
                    visibilityModalForwardMessage, setVisibilityModalForwardMessage
                }
            }>
                {props.children}
            </ChatContext.Provider>
        </>
    )
}